<header [showLoginButton]="true" [showPhone]="false" class="page-header"></header>

<div class="referral-request mx-auto">
  <img
    src="assets/images/referral-request-avatars.webp"
    alt=""
    width="324"
    height="64"
    class="referral-request__avatars"
  />

  <h1 class="semi-bold referral-request__title" data-id="referral-request-title">
    Thank you! Our team is already reviewing your request
  </h1>

  <p class="referral-request__text" data-id="referral-request-text">
    The same travel expert who helps {{ referrerName }} will contact you shortly to discuss your
    trip and confirm your eligibility for the {{ amount | portalCurrency }} travel credit. If
    eligible, book within 3 months to use your credit — you can travel later.
  </p>

  @if (hasTrip) {
    <p class="referral-request__label">Your request</p>

    <div class="referral-request__card" data-id="referral-request-card">
      <p class="referral-request__route semi-bold">
        <span>{{ origin }}</span>
        <img src="assets/icons/sync_alt.svg" alt="" width="20" height="20" />
        <span>{{ destination }}</span>
      </p>
      @if (tripMeta) {
        <p class="referral-request__meta">{{ tripMeta }}</p>
      }
    </div>
  }
</div>

<footer></footer>
